/* eslint-disable @typescript-eslint/ban-ts-comment */
import { store } from '@/store';
import { BaseCompoundFormFieldBuilder } from '.';
import { ArrayFormField, FormFieldType } from '../typings';
import { setConditionalParentFields } from '../store';

export class ArrayFormFieldBuilder extends BaseCompoundFormFieldBuilder<ArrayFormField> {
  protected _type = FormFieldType.Array;
  protected _typeValue = FormFieldType.Array;
  // @ts-ignore
  private _title: ArrayFormField['title'] = 'Title not provided';
  // @ts-ignore
  private _entryTitle?: ArrayFormField['entryTitle'];
  // @ts-ignore
  private _isRequired: ArrayFormField['isRequired'] = false;
  // @ts-ignore
  private _isMultiple: ArrayFormField['isMultiple'] = false;
  // @ts-ignore
  private _isEmpty: ArrayFormField['isEmpty'] = true;
  // @ts-ignore
  private _clearsToEmpty?: ArrayFormField['clearsToEmpty'];
  // @ts-ignore
  private _providerAdded?: ArrayFormField['providerAdded'];
  // @ts-ignore
  private _maxItems?: ArrayFormField['maxItems'];
  // @ts-ignore
  private _minItems?: ArrayFormField['minItems'];
  // @ts-ignore
  private _index: ArrayFormField['index'] = 0;
  // @ts-ignore
  private _questionIfOptional?: ArrayFormField['questionIfOptional'];
  // @ts-ignore
  private _isCollapsible: ArrayFormField['isCollapsible'] = false;
  // @ts-ignore
  private _allowRemove: ArrayFormField['allowRemove'];
  // @ts-ignore
  private _titleWhenFilled?: ArrayFormField['titleWhenFilled'];
  // @ts-ignore
  private _hintWhenFilled?: ArrayFormField['hintWhenFilled'];
  // @ts-ignore
  private _fields: ArrayFormField['fields'] = [];
  // @ts-ignore
  private _restriction: ArrayFormField['restriction'];
  // @ts-ignore
  private _address?: ArrayFormField['address'];

  constructor() {
    super();
  }

  public address(value: ArrayFormField['address']): this {
    this._address = value;
    return this;
  }

  public restriction(value: ArrayFormField['restriction']): this {
    this._restriction = value;
    return this;
  }

  public title(value: ArrayFormField['title']): this {
    this._title = value;
    return this;
  }

  public entryTitle(value: ArrayFormField['entryTitle']): this {
    this._entryTitle = value;
    return this;
  }

  public isRequired(value: ArrayFormField['isRequired']): this {
    this._isRequired = value;
    return this;
  }

  public isMultiple(value: ArrayFormField['isMultiple']): this {
    this._isMultiple = value;
    return this;
  }

  public isEmpty(value: ArrayFormField['isEmpty']): this {
    this._isEmpty = value;
    return this;
  }

  public clearsToEmpty(value: ArrayFormField['clearsToEmpty']): this {
    this._clearsToEmpty = value;
    return this;
  }

  public providerAdded(value: ArrayFormField['providerAdded']): this {
    this._providerAdded = value;
    return this;
  }

  public maxItems(value: ArrayFormField['maxItems']): this {
    this._maxItems = value;
    return this;
  }

  public minItems(value: ArrayFormField['minItems']): this {
    this._minItems = value;
    return this;
  }

  public index(value: ArrayFormField['index']): this {
    this._index = value;
    return this;
  }

  public questionIfOptional(value: ArrayFormField['questionIfOptional']): this {
    this._questionIfOptional = value;
    return this;
  }

  public isCollapsible(value: ArrayFormField['isCollapsible']): this {
    this._isCollapsible = value;
    return this;
  }

  public allowRemove(value: ArrayFormField['allowRemove']): this {
    this._allowRemove = value;
    return this;
  }

  public titleWhenFilled(value: ArrayFormField['titleWhenFilled']): this {
    this._titleWhenFilled = value;
    return this;
  }

  public hintWhenFilled(value: ArrayFormField['hintWhenFilled']): this {
    this._hintWhenFilled = value;
    return this;
  }

  // TODO: Add method to add single field
  public fields(value: ArrayFormField['fields']): this {
    this._fields = [...value];

    const childrenIds = this._fields.map(child => child.fieldId);

    store.dispatch(
      setConditionalParentFields({
        [this._fieldId]: childrenIds,
      }),
    );

    return this;
  }
}
